// src/services/pocketbaseApi.js
import { io } from 'socket.io-client';

const apiUrl = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001'; // Adjust if your backend runs on a different port

// Setup socket.io instance
const socket = io(apiUrl);

// Fetch all records (GET)
export async function fetchDemoRecords() {
    const res = await fetch(`${apiUrl}/api/pocketbase-demo`);
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

// Add a record (POST)
export async function addDemoRecord(data) {
    const res = await fetch(`${apiUrl}/api/pocketbase-demo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

// Update a record (PUT)
export async function updateDemoRecord(id, data) {
    const res = await fetch(`${apiUrl}/api/pocketbase-demo/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

// Remove a record (DELETE)
export async function removeDemoRecord(id) {
    const res = await fetch(`${apiUrl}/api/pocketbase-demo/${id}`, {
        method: 'DELETE'
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

// Subscribe to realtime updates (Socket.io)
export function subscribeDemoCollection(callback) {
    socket.on('demo_collection_update', callback);
    return () => socket.off('demo_collection_update', callback);
}

// --- ROOM SOCKET.IO SUPPORT ---
// Subscribe to real-time updates for a specific room's demo_collection
export function subscribeRoomDemoCollection(roomId, callback) {
    socket.emit('join_room', roomId);
    const event = `room_demo_collection_update_${roomId}`;
    socket.on(event, callback);
    return () => {
        socket.emit('leave_room', roomId);
        socket.off(event, callback);
    };
}

// --- ROOM MEMBERS API ---
export async function createRoomMember(roomId, username) {
    const res = await fetch(`${apiUrl}/api/room/${roomId}/members`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username })
    });
    if (!res.ok) throw new Error('Failed to create room member');
    return res.json();
}

export async function removeRoomMember(roomId, username) {
    const res = await fetch(`${apiUrl}/api/room/${roomId}/members/${username}`, {
        method: 'DELETE'
    });
    if (!res.ok) throw new Error('Failed to remove room member');
    return res.json();
}

export { socket };
